import { print } from 'graphql';
import gql from 'graphql-tag';
import type { RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { rootStore } from '../../mobx-models/Root';
import { BaseEntity } from '../../models/BaseEntity';
import { SYNC_LIMIT_LOW } from '../../utilities/constants';
import defaultDoc from '../Shared/defaultDoc';

export interface Crew extends BaseEntity {
  readonly departmentId: string;
  readonly description: string;
  readonly number: string;
  readonly isActive: boolean;
}

export type CrewCollection = RxCollection<Crew> | null;
export type CrewDocument = RxDocument<Crew>;

export const crewSchema: RxJsonSchema<Crew> = {
  type: 'object',
  version: 0,
  description: 'describes a crew object',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    departmentId: { type: 'string' },
    description: { type: 'string' },
    number: { type: 'string' },
    isActive: { type: 'boolean' },
    isDeleted: { type: 'boolean' },
    updatedAt: { type: 'number' },
    version: { type: 'number' },
  },
};

export const crewPullQueryBuilder = (doc: any) => {
  if (!doc) {
    doc = { ...defaultDoc, updatedAt: 0 };
  }
  const query = print(gql`{
          crewFeed (siteId: "${rootStore.user.siteId}", lastUpdateAt: ${doc.updatedAt}, limit: ${SYNC_LIMIT_LOW}){
            departmentId
            description
            id
            isActive
            isDeleted
            number
            updatedAt
            version
          }
        }`);
  return {
    query,
    variables: {},
  };
};

export default {};
